var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRulesShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_8286)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8020_8286",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8020_8286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8020_8286)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8020_8286",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H6V18H18V6Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8020_8286)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56561 6.26074H14.0874C14.7193 6.26074 15.2891 6.64064 15.5322 7.22394L17.4887 11.3978C17.6492 11.7831 17.6492 12.2165 17.4887 12.6018L15.5322 16.7757C15.2891 17.359 14.7193 17.7389 14.0874 17.7389H7.56561C6.70121 17.7389 6.00041 17.0382 6.00041 16.1737C6.00041 15.9671 6.04131 15.7625 6.12081 15.5717L7.65931 12.4011C7.76631 12.1443 7.76631 11.8553 7.65931 11.5985L6.12081 8.42794C5.78831 7.62994 6.16571 6.71354 6.96361 6.38114C7.15441 6.30164 7.35901 6.26074 7.56561 6.26074ZM12.6044 14.7803C12.4111 15.1668 12.5678 15.6369 12.9544 15.8302C13.3409 16.0235 13.8111 15.8668 14.0043 15.4802L15.5695 12.3498C15.6797 12.1295 15.6797 11.8701 15.5695 11.6498L14.0043 8.51944C13.8111 8.13284 13.3409 7.97614 12.9544 8.16944C12.5678 8.36274 12.4111 8.83284 12.6044 9.21944L13.9946 11.9998L12.6044 14.7803Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_8286",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_8286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulesShort);
export default __webpack_public_path__ + "static/media/Rules-Short.e225d6f425f28c20690737446095a612.svg";
export { ForwardRef as ReactComponent };